// extracted by mini-css-extract-plugin
module.exports = {"wrap":"PopupBlock_wrap__1BPwW","body":"PopupBlock_body__3sOCk"};